export default "/fonts/vendor/@fontsource/lato/files/lato-latin-300-normal.woff?60a1fc9096fe55643239b103105ffa41";